export const pages = [
  "Home",
  "Location",
  "Roles",
  "Attire",
  "Gallery",
  "Gift",
  "RSVP",
  "FAQs",
];


export const locations = [
  {
    title: "Ceremony & Reception",
    description: "Emperor Event  Center",
    address: "74 Don Celso Tuazon Ave. Brgy. San Juan Valley Golf, Cainta, Philippines",
    dateTime: "Saturday, January 17, 2026 at 1:00 PM",
    googleUrl: "https://maps.app.goo.gl/qgi6EeyULoabNur28",
    wazeUrl:
      "https://www.waze.com/en/live-map/directions/emperor-event-center-don-celso-tuason-ave-74-cainta?place=w.79364242.793904563.5195240",
  },
];

export const gallery = Array(3)
  .fill("")
  .reduce((arrayData, _, index) => {
    const url = require(`../image/gallery/${index + 1}.jpg`);
    arrayData.push(url);
    return arrayData;
  }, []);

export const faqs = [
  {
    title: "CAN I TAKE PHOTOS/VIDEOS DURING THE CEREMONY?",
    description:
      "OUR CEREMONY IS UNPLUGGED AND WE PLAN TO KEEP IT SOLEMN. WE WOULD LOVE TO CAPTURE YOUR FACES AND NOT YOUR DEVICES.",
    description2:
      "WE INVITE YOU TO BE FULLY PRESENT WITH US. AFTER THE CEREMONY, FEEL FREE TO TAKE AS MANY PHOTOS/VIDEOS AS YOU WANT!",
  },
  {
    title: "WHERE CAN I PARK?",
    description:
      "THERE ARE LOTS OF PARKING SPACES AT THE EVENT VENUE",
  },
  {
    title: "CAN I BRING A DATE/PLUS ONE?",
    description:
      `WE WON'T BE ABLE TO ACCOMMODATE ADDITIONAL GUESTS. WOULD LOVE TO KEEP OUR WEDDING AS INTIMATE AS POSSIBLE WITH CLOSE FRIENDS AND FAMILY.`,
  },
  {
    title: "CAN WE SIT ANYWHERE AT THE RECEPTION?",
    description:
      "IT TOOK US A LOT OF EFFORT AND DISCUSSION TO FINISH THE SEATING ARRANGEMENT WHICH IS PLANNED FOR EVERYONE'S CONVENIENCE AND NETWORK PREFERENCE",
    description2: "YOU'LL BE SEATED ALONG WITH FAMILY AND FRIENDS.",
  },
  {
    title: "CAN I POST WEDDING MOMENTS IN SOCIAL MEDIA?",
    description:
      "OF COURSE! HELP US CAPTURE THE LOVE AFTER THE CEREMONY. ",
  },
  {
    title: "can't make it? change of heart?",
    description:
      "if you rsvp'd yes but can't come or rsvp'd no but has a change of circumstances. let us know asap so we can plan accordingly.",
  },
  {
    title: "when is the appropriate time to leave?",
    description:
      "we aim to end the program by 6pm. please do not eat and run. your presence is the best gift you could give us. please stay until the end of our reception program.",
    description2:
      "if you have to leave early, we'd love to thank and say goodbye before your leave, but perhaps not until our same day edit video is played.",
  },
];

export const roles = {
  name: "Bañaga - Martin",
  title: "Nuptials",
  description: "with the blessing of our parents/guardians",
  roles: {
    "parents of the groom": [["Jerry Hernandez", "Erma Bañaga"]],
    "parents of the bride": [
      ["Toledo Martin", "Mariana Martin"],
    ],
    "guardians of the groom": [
      ["Christopher Ilagan", "Melba Dolotina"],
    ],
    "principal sponsors": [
      ["Joel Felizardo", "Sherill Felizardo"],
      ["Paul Leslie Celestra", "Raychelle Anne Celestra"],
      ["Mike Sarmiento", "Judy Sarmiento"],
      ["Jaime Cortez", "Alalain Cortez"],
      ["Scott Francis De Leon", "Lucie Ching"],
      ["Percival Nacino", "Priscila Tupido"],
      ["Marco Dolotina", "Susan Dolotina"],
      ["Regino Pascual", "Remedios Pascual"],
      ["Niño Socorro", "Aileen Dumlao"],
      ["Arnold Felizardo", "Dianne Jane Tabasa"],
      ["Romel Saldana", "Ma. Theresa Caballero"],
      ["Joel Acsayan", "Cathy Acsayan"],
      ["Marianito Santos", "Clarita Estrellanes"],
    ],
    "best man": ["Tyrone Jerson Bañaga", "Vincent James Bañaga"],
    "maid of honor": ["Ma. Luisa Martin", "Ma. Theresa Martin"],
    groomsmen: [
      "Joerem Bonanza",
      "Richard Lira",
      "Lester Dometita",
      "Roneo Cruz",
    ],
    bridesmaids: [
      "Cristel Bañaga",
      "Ellen Maquiling",
      "Roselle Vega",
      "Aundrea Pauline De Guzman",
    ],
    "secondary sponsors": {
      candle: [["Ebenezer Amante", "Sharlynne Amante"]],
      cord: [["Matthew Sarmiento", "Abigail Sarmiento"]],
      veil: [["Brix Shawn Dawa", "Cheliza Reyes"]],
      "coin bearer": ["Shaun Carl Agustin"],
      "ring bearer": ["Raphael Joseph Dolotino"],
      "bible bearer": ["Fil Shawn Salazar"],
      "flower girl": [
        "Lexandra Preya Celestra",
        "Laurene Anne Dolotino",
        "Cindel Annika Felizardo",
        "Kirstel Anita Felizardo",
      ],
    },
  },
};

